import React from "react";
import SideMenu from "../sideMenu";
import { useLocation } from "react-router-dom";
import DashboardHeader from "../topbar";
import { checkPriority, checkWorkLocation, makeSideBarActive } from "../../utils/EllowUtils";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { useEffect, useState } from 'react'
import { getAppliedCandidate, getPositionsDetails} from "../positions/services";
import { EditorState, convertToRaw, convertFromRaw, Modifier, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import AppliedCandidates from './appliedCandidates'
import { updateLossCountAPI, updatePositionAPI } from "./services";
import { Navigate, useNavigate } from "react-router-dom";
import ConfirmationModal from '../../modal/confirmation/confirmationModal';
import CrowdSourcingModal from "../../modal/crowdSourcing";
import NotificationAlert from "../../components/notification";
import mixpanelData, { viewedpageMixpanel } from "../../utils/mixpanel";
import { updateNotificationStatus } from "../../components/noticationTab/services";
import { updateCrowdSourcingStatus , getCsrAppliedCandidates , postCandidateToJob, getProviderResources } from './services'

function PositionDetails() {

  const navigate = useNavigate()
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 1);
  const [companyPositionName, setCompanyPositioName] = useState<string>()
  const [Company, setCompany] = useState<string>()
  const [jobsId, setJobsId] = useState<any>()


  const location = useLocation();
  const jobId: any = localStorage.getItem('PositionsJobId') || location.state.jobId || ''
  const positionName: any = localStorage.getItem('PositionsPositionName') || location?.state.positionName || ''
  const companyName: any = localStorage.getItem('PositionsCompanyName') || location.state.companyName || ''
  const loginId = localStorage.getItem('loginId')
  const { notificationsId }: any = location.state || ''

  const [crowdSouring, setCrowdSouring] = useState<boolean>(false)
  const [positionData, setPositionData] = useState<any>()
  const [customerId, setCustomerId] = useState<string>('')
  const [allocatedToId, setAllocatedToId] = useState<any>()
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [modal, setModal] = useState<boolean>(false)
  const [crowdSourcingmodal, setCrowdSourcingmodal] = useState<boolean>(false)
  const [value, setValue] = useState<any>()
  const [editorState, setEditorState] = useState<any>(EditorState.createEmpty())
  const [appliedResources, setAppliedResources] = useState([])
  const [csrappliedResources, setCsrAppliedResources] = useState([])
  const [csrappliedResourcesCount, setCsrAppliedResourcesCount] = useState([])
  const [providerResources, setProviderResources] = useState([])
  const [providerResourcesCount, setProviderResourcesCount] = useState([])
  const [jobStatus, setJobStatus] = useState<number>()
  const [jobMetadata, setJobMetadata] = useState<{
    resourceCount: any, experienceRange: any, contractDuration: string, contractStartDate: number, minimumBudget: number, maximumBudget: number,
    billingType: string, jobRole: { id: number, name: string }, coreSkills: [{ skillId: number, skillName: string }], otherSkills: [{ skillId: number, skillName: string }],
    closedCount: any, jobDescription: string, priority: number, lossCount: number, supportingDocument: string, locationPreference: any, jobType: any, currencyType: string
  }>({
    resourceCount: 0, experienceRange: 0, contractDuration: "", contractStartDate: 0, minimumBudget: 0, maximumBudget: 0,
    billingType: "", jobRole: { id: 0, name: "" }, coreSkills: [{ skillId: 0, skillName: "" }], otherSkills: [{ skillId: 0, skillName: "" }],
    closedCount: 0, jobDescription: "", priority: 5, lossCount: 0, supportingDocument: "", locationPreference: {}, jobType: '', currencyType:''

  })
  
  const updateNotification = (notificationId: any) => {

    updateNotificationStatus(notificationId).then((response: any) => {
      if (response && response.status === "success") {
      }
    });
  };
  useEffect(() => {
    
    if (notificationsId != '') {
      updateNotification(notificationsId);
    }
    setCompanyPositioName(positionName)
    setCompany(companyName)
    setJobsId(jobId)
    getPositionDetails(jobId)
    getAppliedCandidates(jobId)
    getCsrAppliedCandidate (jobId)
    viewedpageMixpanel();

  }, []);

  let BreadcrumsValues = ['Positions', companyPositionName + ' - ' + Company]

  const getPositionDetails = (jobId: string) => {
    getPositionsDetails(jobId).then(
      (response) => {
        if (response && response.status === 1) {
          setPositionData(response.data[0])
          setAllocatedToId(response.data[0].allocated_to)
          setJobMetadata(response.data[0].job_metadata)
          setJobStatus(response.data[0].job_status)
          setCustomerId(response.data[0].company_id)
        }
      }
    );
  }

  const getAppliedCandidates = (jobId: string) => {
    getAppliedCandidate(jobId).then((resp) => {
      if (resp && resp.status === 1) {
        setAppliedResources(resp.data)
      }
    })
    getCsrAppliedCandidates(jobId, loginId).then((resp) => {
      if (resp && resp.status === 1) {
        setCsrAppliedResources(resp.data.data)
        setCsrAppliedResourcesCount(resp.data.count)
      }
    })
    getProviderResources(jobId).then((resp: any) => {
      if( resp && resp.status === 1){
        setProviderResources(resp.data)
        setProviderResourcesCount(resp.count)
      }
    })
  }

  const getCsrAppliedCandidate = (jobId: string) => {
    // getCsrAppliedCandidates(jobId, loginId).then((resp: any) => {
    //   if (resp && resp.status === '1') {
    //     setCsrAppliedResources(resp.data)
    //   }
    // })
  }

  const pageChange = (data: any) => {

  }

  const pageSize = (pageSize: any, pageNumber: number) => {
    // props.pageSize(pageSize, pageNumber)

  }

  const convert = (item: any) => {

    if (item) {
      const contentState = editorState.getCurrentContent();
      if (JSON.stringify(convertToRaw(contentState)) !== item) {
        try {
          let abd = draftToHtml(convertToRaw(EditorState.createWithContent(convertFromRaw(JSON.parse(item))).getCurrentContent()))
          let strippedHtml = abd.replace(/<[^>]+>/g, '');
          return strippedHtml

        }
        catch (e) {
          return item
        }

      }
    }
  }

  const deletePosition = () => {
    
    let value = {
      "loginId": loginId,
      "jobId": jobsId,
      "userLoginId": loginId,
      "action": "delete",
      "submittedBy" : 'RECRUITER'
    }
    setValue(value)
    setModal(true)
  }

  const closePosition = () => {
    let value = {
      "loginId": loginId,
      "jobId": jobsId,
      "userLoginId": loginId,
      "action": "close",
      "submittedBy" : 'RECRUITER'

    }
    setValue(value)
    setModal(true)
  }

  const reopenPosition = () => {
    if(Math.floor((jobMetadata.resourceCount)-(jobMetadata.closedCount)-(jobMetadata.lossCount)) > 0){
      let value = {
        "loginId": loginId,
        "jobId": jobsId,
        "userLoginId": loginId,
        "action": "reopen",
        "submittedBy" : 'RECRUITER'
  
      }
      setValue(value)
      setModal(true)
    }else{
      setMessage("This position cannot be reopen since there are no active positions")
      setNotification(true)
      setTimeout(() => {
        setNotification(false)
      }, 4000)
    } 
  }

  const submit = (data?: any) => {

    

    updatePositionAPI(data ? data : value).then((response) => {
      if (response && response.status === 1) {
        if (value.action === "delete") {
          setMessage("Position deleted")
        }
        if (value.action === "reopen") {
          setMessage("Position reopened")
        }
        if (value.action === "close") {
          setMessage("Position closed")
        }
        mixpanelData(value.action === "close" ? `TG - Positions Closed` : `TG - Position ${value.action}d`, {
          'source': `Recruiter changed position to ${value.action}`,
          'Position Changed to': value.action,
          'Company Name': Company,
          'Position Name': companyPositionName,
          'distinct_id': localStorage.getItem('Email'),
          'Recruiter Email': localStorage.getItem('Email'),
          'jobId': jobsId,
          'jobRole': jobMetadata && jobMetadata.jobRole && jobMetadata.jobRole.name,
          'Active position': jobMetadata && jobMetadata.resourceCount,
          'Experience range': JSON.stringify(jobMetadata.experienceRange),
          'core Skills': jobMetadata && jobMetadata.coreSkills && jobMetadata.coreSkills.length > 0 && jobMetadata.coreSkills.map((item: any) => item.skillName),
          'other Skills': jobMetadata && jobMetadata.otherSkills && jobMetadata.otherSkills.length > 0 && jobMetadata.otherSkills.map((item: any) => item.skillName),
          'work Location': jobMetadata && jobMetadata.locationPreference && checkWorkLocation(jobMetadata.locationPreference.remoteType, jobMetadata.locationPreference?.location),
          'contract start date': jobMetadata && jobMetadata.contractStartDate && (new Date(jobMetadata.contractStartDate)).toDateString(),
          'priority': jobMetadata && jobMetadata.priority && checkPriority(jobMetadata.priority)
        })
        mixpanelData(value.action === "close" ? `New TG - Positions Closed` : `New TG - Position ${value.action}d`, {
          'Source': `Recruiter changed position to ${value.action}`,
          'Position changed to': value.action,
          'Company name': Company,
          'Position name': companyPositionName,
          'distinct_id': localStorage.getItem('Email'),
          'Recruiter email': localStorage.getItem('Email'),
          'JobId': jobsId,
          'Job role': jobMetadata && jobMetadata.jobRole && jobMetadata.jobRole.name,
          'Active position': jobMetadata && (jobMetadata.resourceCount)-(jobMetadata.closedCount)-(jobMetadata.lossCount),
          'Experience': jobMetadata.experienceRange && `${jobMetadata.experienceRange.min} - ${jobMetadata.experienceRange.max} Years`,
          'Core skills': jobMetadata && jobMetadata.coreSkills && jobMetadata.coreSkills.length > 0 && jobMetadata.coreSkills.map((item: any) => item.skillName),
          'Other skills': jobMetadata && jobMetadata.otherSkills && jobMetadata.otherSkills.length > 0 && jobMetadata.otherSkills.map((item: any) => item.skillName),
          // 'Work location': jobMetadata && jobMetadata.locationPreference && checkWorkLocation(jobMetadata.locationPreference.remoteType, jobMetadata.locationPreference?.location),
          // 'Work LocationArray': locations,
          'Contract start date': jobMetadata && jobMetadata.contractStartDate && (new Date(jobMetadata.contractStartDate)).toDateString(),
          'Priority': jobMetadata && jobMetadata.priority && checkPriority(jobMetadata.priority),
          'Allocated to': response.data && response.data[0].allocatedToName,
          'Job type': jobMetadata && jobMetadata.jobType,
          'Crowdsourcing enabled': crowdSouring,
          'Budget': jobMetadata && jobMetadata.minimumBudget + ' - ' + jobMetadata.maximumBudget + ' ' + jobMetadata.currencyType + '/' + jobMetadata.billingType
        })
        displayNotification()
      }
    })
  }

  const editPosition = () => {
    getPositionsDetails(jobsId).then(
      (response) => {
        if (response && response.status === 1) {
          navigate('/createPositions', { state: { data: response.data[0], jobId: response.data[0].job_id, jobStatus: response.data[0].job_status, publishKey: 'update' } })
        }
      }
    );
  }


  const updatePosition = (value: string) => {
  
    switch (value) {
      case 'delete':
        return deletePosition();
      case 'close':
        return closePosition();
      case 'edit':
        return editPosition();
      case 'reopen':
        return reopenPosition();
    }
  }

  const updateLossCount = (data: any) => {
    const newData = {
      userLoginId: loginId,
      jobId: jobsId,
      jobMetadata: {
        lossCount: parseInt(data)
      }
    }
    updateLossCountAPI(newData).then((response) => {
      if (response && response.status === 1) {  
        if( (jobMetadata.resourceCount) - (jobMetadata.closedCount + parseInt(data)) === 0){
          let value1 = {
            "loginId": loginId,
            "jobId": jobsId,
            "userLoginId": loginId,
            "action": "close",
            "submittedBy" : 'RECRUITER'
          }
          setValue(value1)
          submit(value1)
          mixpanelData( `New TG - Positions Closed`, {
            'Source': `Position closed`,
            'Position changed to': 'closed',
            'Company name': Company,
            'Position name': companyPositionName,
            'distinct_id': localStorage.getItem('Email'),
            'Recruiter email': localStorage.getItem('Email'),
            'JobId': jobsId,
            'JobRole': jobMetadata && jobMetadata.jobRole && jobMetadata.jobRole.name,
            'Active position': 0,
            'Experience range': jobMetadata.experienceRange,
            'Core skills': jobMetadata && jobMetadata.coreSkills && jobMetadata.coreSkills.length > 0 && jobMetadata.coreSkills.map((item: any) => item.skillName),
            'Other skills': jobMetadata && jobMetadata.otherSkills && jobMetadata.otherSkills.length > 0 && jobMetadata.otherSkills.map((item: any) => item.skillName),
            'Work location': jobMetadata && jobMetadata.locationPreference && checkWorkLocation(jobMetadata.locationPreference.remoteType, jobMetadata.locationPreference?.location),
            // 'Work LocationArray': locations,
            'Contract start date': jobMetadata && jobMetadata.contractStartDate && (new Date(jobMetadata.contractStartDate)).toDateString(),
            'Priority': jobMetadata && jobMetadata.priority && checkPriority(jobMetadata.priority),
            'Allocated to': response.data && response.data[0].allocatedToName,
            'Job type': jobMetadata && jobMetadata.jobType,
            'Crowdsourcing enabled': crowdSouring
          })
        }
        getPositionDetails(jobId)
        mixpanelData('New TG - Position Loss count Updated', {
          'Source': `Recruiter ${data.action}ed a position`,
          "distinct_id": localStorage.getItem('Email'),
          "Position name": positionName,
          "Company name": companyName,
          'Loss count': parseInt(data),
          'Resource count': jobMetadata.resourceCount,
          "Job id": jobsId,
          'Job type': jobMetadata && jobMetadata.jobType,
          'Job role': jobMetadata && jobMetadata.jobRole && jobMetadata.jobRole.name,
          'Active count': (parseInt(jobMetadata.resourceCount) )- (parseInt(data) + parseInt(jobMetadata.closedCount))
        })
      }
    })
  }

  const displayNotification = () => {
    setNotification(true)
    setTimeout(() => {
      navigate('/positions')
      setNotification(false)
    }, 3000)
  }

  const crowdsourcingChange = (data: any) => {
 
    if(jobMetadata && (Math.floor((jobMetadata.resourceCount)-(jobMetadata.closedCount)-(jobMetadata.lossCount))) > 0){
      if(data === 'Enable crowdsourcing'){
        setCrowdSouring(true)
        setCrowdSourcingmodal(true)
      }
      if(data === 'Disable crowdsourcing'){
        setCrowdSouring(false)
        setCrowdSourcingmodal(true)
      }  
    }else{
      setMessage("Can’t update crowdsourcing, since there is no active positions!")
      setNotification(true)
      setTimeout(() => {
        setNotification(false)
      }, 4000)
    }
  }

  const submitCrowdSourcingStatus = (data: any) => {

    let value = {
      "jobId": jobId,
      "status": crowdSouring,
      "companyDetails": data.companyDetails,
      "userLoginId": loginId
    }    
    updateCrowdSourcingStatus(value).then((response: any) => {
      if (response && response.status === 1) {
        mixpanelData('New TG - Position Crowd sourcing updated', {
          'source': "Crowd sourcing is updated from position details",
          'distinct_id': localStorage.getItem('Email'),
          'Recruiter email': localStorage.getItem('Email'),
          'Position name': positionName,
          "Job role": jobMetadata && jobMetadata.jobRole && jobMetadata.jobRole.name,
          "JobId": jobsId,
          'Company name': companyName,
          'Allocated To': response && response.data[0].allocatedToName,
          'crowdsourcing enabled': crowdSouring,
          "Active position" : jobMetadata && jobMetadata.resourceCount
        })
        setCrowdSourcingmodal(false)
        if(crowdSouring === true){ 
          setMessage("Crowdsourcing enabled successfully")
        }else{
          setMessage("Crowdsourcing disabled successfully")
        }
        setNotification(true)
        setTimeout(() => {
          setNotification(false)
        }, 4000)
        getPositionDetails(jobId)
      }
    })
  }

 
  const onClose = () => {
    setNotification(false)
  }

  const positionDetails = () => {
    setTimeout(() => {
      getPositionDetails(jobId)
    }, 3000)
  }

  const submitPostCandidateToJob = (data: any) => {

    postCandidateToJob(data).then((response) => {
      if (response && response.status === 1){
        setMessage("Resource submitted successfully!")
        setNotification(true)
        setTimeout(() => {
          setNotification(false)
        }, 4000)
      }
      getAppliedCandidates(jobId)
    })
  
  }

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          searchChange={undefined}
          popupMenu={true}
          jobId={jobsId}
          companyName={companyName}
          updatePosition={updatePosition}
          jobStatus={jobStatus}
          priority={jobMetadata.priority}
          positionData={positionData}
          crowdsourcingChange={crowdsourcingChange}
          allocatedToId={allocatedToId}
        />

        < AppliedCandidates jobStatus={jobStatus} jobMetadata={jobMetadata} pageChange={pageChange} pageSize={pageSize} convert={convert} appliedResources={appliedResources} jobId={jobsId} companyName={companyName} getAppliedCandidates={() => getAppliedCandidates(jobsId)} lossCount={updateLossCount} customerId={customerId} getPositionDetails={positionDetails} allocatedToId={allocatedToId} 
          csrappliedResources={csrappliedResources} submitPostCandidateToJob={submitPostCandidateToJob} positionData={positionData} providerResources={providerResources} providerResourcesCount={providerResourcesCount} csrappliedResourcesCount={csrappliedResourcesCount}/>
        {modal && <ConfirmationModal onClose={() => setModal(false)} submit={submit} />}
        {notification && <NotificationAlert onClose={onClose} closable={true} >{message}</NotificationAlert>}
        {crowdSourcingmodal && <CrowdSourcingModal onClose={() => setCrowdSourcingmodal(false)} enable={crowdSouring} ClickHandler={submitCrowdSourcingStatus} companyDetails={positionData && positionData.crowdsourcing_company_details}/>}
      </div>
    </section>
  );
}
export default PositionDetails;